<template>
  <div class="layout-container">
    <Header v-once/>
    <app-main/>
    <Footer v-once/>
  </div>
</template>

<script>
import Header from './Header/index'
import Footer from './Footer/index'
import AppMain from './AppMain'
export default {
  name: 'Layout',
  components: { Header, Footer, AppMain },
  mixins: [],
  data() {
    return {}
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.layout-container {
  height: 100%;
}
</style>
